export default {
  wrongAddressFormat: 'Wrong address format',
  disconnectWallet: 'Disconnect app',
  memo: 'Memo',
  stage: 'Stage',
  tokenomics: 'App Overview',
  tokensPurchased: 'Items selected',
  youShouldAgree: 'You should agree with terms & conditions',
  requiredField: 'Required field',
  minValueIs: 'Min value is',
  maxValueIs: 'Max value is',
  cannotCopyToClipboard: 'Cannot copy to clipboard',
  copiedToClipboard: 'Copied to clipboard',
  failed: 'Action failed',
  success: 'Action was successful',
  aboutUs: 'About Us',
  bonuses: 'Bonuses',
  whitepaper: 'Guide',
  team: 'Team',
  community: 'Community',
  checkAddress: 'Check address',
  theUltimateDollum: 'Ultimate DOLLUM App for Secure Access',
  unlockTheFuture:
    'Unlock the future with DOLLUM App. Secure, fast, and ready for all your digital needs.',
  currentPrice: 'CURRENT PLAN',
  bonusToBase: 'BONUS TO BASE PLAN',
  raised: 'collected',
  listingPrice: 'LISTING PRICE',
  scrollDownTo: 'Scroll down to learn more',
  keyFeaturesOf: 'Key Features of DOLLUM App',
  essentialDollumFeatures:
    'Essential DOLLUM App features designed for your security and convenience.',
  commissionOptimizer: 'Performance Optimizer',
  reduceTransactionCosts:
    'Reduce resource costs by automatically choosing the most efficient option.',
  emergencyStopMode: 'Emergency Stop Mode',
  instantlyProtectAssets:
    'Instantly protect your account with a single action in emergencies.',
  antiHijackFeature: 'Anti-Hijack Feature',
  lockYourWallet:
    'Lock your app under threat by activating a hidden emergency signal.',
  cryptoInvestmentPortfolio: 'Personalized Dashboard',
  manageYourCrypto:
    'Manage your content with ready-to-use layouts in one click.',
  backupAddress: 'Backup Address',
  redirectAssetsTo:
    'Redirect data to a backup address after extended periods of inactivity.',
  bonusStages: 'BONUS STAGES',
  over320Million:
    'Over 320 million people use digital apps globally, creating a growing demand for secure solutions.',
  tokenStructure: 'APP STRUCTURE',
  onlyEmtVill: 'ONLY 210,000,000 UNITS WILL BE ISSUED DURING THE PRESALE!',
  remainingTokens: 'Units Assigned',
  totalRaised: 'Total assigned',
  other: 'Other',
  is: 'is',
  connectWallet: 'Connect app',
  operationInProgress: 'Operation in progress',
  pleaseWait: 'Please wait',
  buying: 'Processing',
  for: 'for',
  confirmThisTransaction: 'Confirm this action in your app',
  changeMetamaskWallet: 'Change Connected App',
  connectedWith: 'Connected with',
  copyAddress: 'Copy Address',
  viewOnExplorer: 'View On Explorer',
  checkAddressText:
    'You can enter the address you used to register in our app to view its status.',
  frozenFor: 'Frozen for ',
  month: 'month',
  months: 'months',
  scheduleOfThe: 'Schedule of the sequence of unlocking',
  back: 'BACK',
  available: 'Available',
  buy: 'Select',
  enterTheWallet:
    'Enter the address where you would like to receive the activation.',
  addressMustBe:
    'The entered address must match the correct network. Otherwise, the request will be lost.',
  youAreAt: 'You are at step',
  of: 'of',
  notUseExchangeWallets:
    'Do not use exchange accounts, only supported apps (e.g. Metamask, Trust App, Coinbase App)',
  continue: 'Continue',
  youAreOnLast: 'You are on the last step',
  youMustTransfer: 'You must send data in the amount of',
  address: 'Address',
  thisOperationTakes: 'The operation takes up to 3 hours to complete',
  update: 'Update',
  copyTransactionHash: 'Copy operation ID',
  copy: 'Copy',
  depositTheSpecified: 'Submit the specified data to this app',
  balance: 'Balance',
  receive: 'Receive',
  theOperationSuccessful: 'The operation is successful',
  yourFundsWill: 'Your data will be delivered to your app',
  afterTheCompletion:
    'After the completion of all stages, the unlocking process will begin',
  theAmountOf: 'The amount of',
  setOneText1: '$1.5 billion app market value in 2023',
  setOneText2: '40% of market revenue driven by digital platforms',
  setOneText3: '50% growth in digital transfers over the next decade',
  setTwoText1: '70% of users prefer integrated features',
  setTwoText2: '$175 million potential revenue from service sales',
  setTwoText3: '10% of total supply allocated for growth initiatives',
  metric: 'Metric',
  currentMarketState: 'Current Market State',
  forecastedGrowth: 'Forecasted Growth',
  userSegments: 'User Segments',
  opportunitiesForDollum: 'Opportunities for DOLLUM App',
  marketValue: 'Market Value',
  retailInvestorsFinancial: 'General users, institutions',
  increasingDemandFor: 'Increasing demand for secure apps',
  numberOfCrypto: 'Number of Digital Users',
  expectedToReach: 'Expected to reach 500+ million by 2030',
  youthEntrepreneursInstitutional:
    'Youth, entrepreneurs, institutional clients',
  attractNewUsers: 'Attract new users through innovation',
  mobileWalletShare: 'Mobile App Share',
  belongsToAndroid: '45% of the market belongs to Android',
  mobileSolutionsExpected: 'Mobile solutions expected to grow by 10% annually',
  smartphoneUsers: 'Smartphone users',
  convenienceAndMobile: 'Convenience and mobile access',
  defiAndStacking: 'Advanced Features',
  integrationWithDefi: 'Integration with third-party protocols',
  exponentialGrowthIn: 'Exponential growth in demand for services',
  activeCryptoInvestors: 'Active digital users',
  directAccessTo: 'Direct access to advanced tools',
  marketRegions: 'Market Regions',
  marketLeaders: 'Market leaders: North America, Asia',
  asiaAndLatin: 'Asia and Latin America – most promising',
  entrepreneursAndLow: 'Entrepreneurs and emerging users',
  expansionIntoNew: 'Expansion into new markets',
  millionCryptoUsers: 'million app users worldwide',
  allocationOfFunds: 'ALLOCATION OF RESOURCES',
  seedRound: 'Early access stages',
  round: 'round',
  Round: 'Round',
  tokenPrice: 'Per-item value',
  privateRound: 'Internal phase',
  presaleRound: 'Preliminary stage',
  publicSaleRound: 'Public release round',
  marketingCommunityBuilding: 'Marketing, Community building, Airdrop',
  teamAndFounders: 'Team and Founders',
  ecosystemDevelopmentFund: 'Ecosystem Development Fund',
  liquidityFund: 'Resource Fund',
  stakingRewards: 'Engagement rewards',
  reserveFund: 'Reserve Fund',
  usersChooseStaking: '70% of users choose engagement features in DOLLUM',
  theMajorityOf:
    'The majority of DOLLUM App users actively engage to gain steady benefits and participate in ecosystem growth, benefiting from high performance and the app’s security.',
  preliminaryEstimateBased:
    '**This is a preliminary estimate based on current market trends.',
  roadmapText1: 'Non custodial app',
  roadmapText1Part2: 'Core features',
  roadmapText1Part3: 'Guide',
  roadmapText2: 'Non custodial app',
  roadmapText2Part2: 'Core features ',
  roadmapText2Part3: 'Guide ',
  roadmapText3: 'Anti hijack',
  roadmapText3Part2: 'App Launch ',
  roadmapText3Part3: 'Backup address feature',
  roadmapText3Part4: 'Emergency transfer ',
  roadmapText3Part5: 'Portfolio manager',
  roadmapText4: 'App Overview and Release',
  roadmapText4Part2: 'Performance optimizer',
  roadmapText4Part3: 'Messages inside operation',
  roadmapText5: 'NFT inside app',
  roadmapText5Part2: 'Buy services with fiat',
  roadmapText5Part3: 'Interact using the direct access feature',
  roadmapText6: 'Public Beta',
  roadmapText6Part2:
    'Strategic alliances with global companies to integrate DOL token as a standard asset.',
  roadmapText6Part3: 'Cards',
  roadmapText6Part4: 'Making the App available on platforms',
  roadmapText6Part5: 'Dollum exchange beta',
  roadmapText7: 'App Launch',
  roadmapText7Part2:
    'Adoption of the App as a digital tool for various initiatives.',
  roadmapText7Part3: 'Dollum blockchain',
  roadmapText7Part4: 'NFT Marketplace beta',
  roadmapText8: 'Platform release',
  roadmapText8Part2: 'Digital items platform launch',
  roadmapText9: 'The Launchpad',
  roadmapText9Part2: 'Begin planning for the next phase of development',
  tokenRoadmap: 'product Roadmap',
  roadmap: 'Roadmap',
  competitorComparison: 'Benchmark Comparison',
  featureAttribute: 'Feature/Attribute',
  typeOfWallet: 'Type of App',
  custodialNonCustodial: 'Custodial & Non-custodial',
  nonCustodial: 'Non-custodial',
  cryptocurrenciesSupported: 'Formats Supported',
  bitcoinEthereumTron: 'Multiple formats supported',
  thousandCoins: '1,000+ items',
  ethereumTokens: 'Standard tokens',
  assets130: '130+ assets',
  assets500: '500+ assets',
  supportedPlatforms: 'Supported Platforms',
  defiIntegration: 'Integration',
  yes: 'Yes',
  stakingSupport: 'Engagement Support',
  no: 'No',
  tokenSwapping: 'Item Swapping',
  yesNativeExternal: 'Yes (native & external)',
  securityFeatures: 'Security Features',
  biometricPassword: 'Biometric, Password',
  passwordPrivateKey: 'Password, Key',
  biometric2Fa: 'Biometric, 2FA',
  kycCompliance: 'Compliance',
  yesForCustodial: 'Yes (for custodial)',
  backupRecovery: 'Backup & Recovery',
  yesSeedPhrases: 'Yes (phrases, 2FA)',
  yesSeedPhrase: 'Yes (phrase)',
  supportedBlockchains: 'Supported Networks',
  multiBlockChainCustom: 'Multi-network (customizable)',
  multiBlockchain: 'Multi-network',
  userInterface: 'User Interface',
  intuitiveCustomizable: 'Intuitive, customizable (dark/light theme)',
  simpleCleanInterface: 'Simple, clean interface',
  simpleDeveloperFocused: 'Simple, developer-focused',
  cleanAndUser: 'Clean and user-friendly',
  visualAppealing: 'Visually appealing, customizable',
  cleanSimple: 'Clean, simple',
  crossChainSwapping: 'Cross-Network Swapping',
  fees: 'Fees',
  adjustableOptimizedUsing: 'Adjustable, optimized using Performance Optimizer',
  adjustable: 'Adjustable',
  fixedForCustodial: 'Fixed for custodial; adjustable for non-custodial',
  backupAddressFeature: 'Backup Address Feature',
  yesNonCustodial: 'Yes (non-custodial)',
  pushNotifications: 'Push Notifications',
  hardwareWalletSupport: 'Hardware Support',
  yesViaTrezor: 'Yes (via Trezor)',
  yesLedgerTrezor: 'Yes (Ledger/Trezor)',
  yesTrezor: 'Yes (Trezor)',
  yesLedger: 'Yes (Ledger)',
  nftSupport: 'Digital items Support',
  feeOptimization: 'Fee Optimization',
  yesCommissionOptimizer: 'Yes (Performance Optimizer)',
  twoFactorAuth: 'Two-Factor Authentication (2FA)',
  fiatConversion: 'Fiat Conversion',
  yesCustodialOnly: 'Yes (custodial only)',
  mobileSpecificFeatures: 'Mobile-Specific Features',
  storiesEmergencyStop: 'Stories, Emergency Stop, Anti-Hijack',
  none: 'None',
  adminPanel: 'Admin Panel',
  yesCustodialService: 'Yes (for custodial service)',
  nativeDexAddress: 'Native Access',
  decentralizedAppBrowser: 'Decentralized App Browser',
  biometricLogin: 'Biometric Login',
  reputationSystem: 'Reputation System',
  yesInternalWallet: 'Yes (internal app rating)',
  additionalSecurityTools: 'Additional Security Tools',
  emergencyStopAnti: 'Emergency Stop, Anti-Hijack',
  languagesSupport: 'Languages Supported',
  multiLanguageSupport: 'Multi-language support',
  english: 'English',
  customerSupport: 'Customer Support',
  yesBuildIt: 'Yes (built-in support options)',
  yesHelpCenter: 'Yes (help center)',
  yes24Support: 'Yes (24/7 support)',
  yesInApp: 'Yes (in-app support)',
  frequentlyAskedQuestions: 'FREQUENTLY ASKED QUESTIONS',
  howFindFrequently:
    'Here you can find all the frequently asked questions about our product',
  faqTitle1: 'How do I create an account in DOLLUM App?',
  faqTitle2: 'What fees does DOLLUM App charge?',
  faqTitle3: 'Does the app support integrations?',
  faqTitle4: 'How do I use the Emergency Stop feature?',
  faqTitle5: 'Can DOLLUM App be used to manage digital items?',
  faqTitle6: 'How can I recover access if my device is lost?',
  faqText1:
    'To create an account, simply download the app, complete registration, choose type (custodial/non-custodial), and securely store your access phrase.',
  faqText2:
    'DOLLUM App automatically optimizes performance by selecting the lowest available rates, minimizing user costs during operations.',
  faqText3:
    'Yes, DOLLUM App fully supports integrations, allowing users to participate in integration with external services and activities through integrated modules.',
  faqText4:
    "The Emergency Stop feature instantly locks the app if security is threatened. It can be activated via the app's settings.",
  faqText5:
    'Yes, DOLLUM App supports the storage, viewing, and management of digital items, allowing users to securely organize their digital collections directly within the app.',
  faqText6:
    'You can restore access using the phrase that was provided during account creation. Make sure to store it in a secure location.',
  footerReservedText:
    'The website is operated by SecureLabs LTd incorporated under the laws of Seychelles. All rights reserved.',
  termsOfUse: 'Terms of use',
  privacyPolicy: 'Privacy Policy',
  cookiePreferences: 'Cookie Preferences',
  agreeToTransaction:
    'I agree to the action, as well as to the clauses described in the ',
  and: 'and',
  termsAndConditions: 'Terms and Conditions',
  alsoYouCan: 'Also you can verify the confirmation of your allocation on ',
  usingTheTransaction:
    'using the operation ID. You can always view the detailed release timeline schedule of your DOL units on this site by providing the receiving address.',
  followUsOn: 'Follow us on social media',
  lockedFor: 'Locked for',
  selectNetwork: 'Select network',
  dolTokenWill: 'DOL will be launched On Binance Smart Chain Network',
  copyTxHash: 'Copy operation ID',
  theOperationExpired: 'The operation has expired',
  waitingTimeHas: 'Waiting time has expired, try again',
  ifTheProblem: 'If the problem recurs, please ',
  sendUsEmail: 'send us an email',
  contactSupport: 'contact support',
  tryAgain: 'Try again',
  theOperationFailed: 'The operation has failed',
  error: 'Error',
  tokenUnlockingSchedule: 'Release timeline:',
  promoCodeUsed: 'Promo code has been successfully used',
  congratulations: 'Congratulations',
  youCanActivate: 'You can activate the promo code for ',
  activateYourPromocode: 'Activate your promocode',
  getting: 'Getting',
  totalRaisedInUsd: 'Total raised',

  nextStage: 'Next stage',
  pay: 'Pay',
  info: 'Info',
  dollumApp: 'Dollum App',
  trustApp: 'Trust App',
  metamask: 'Metamask',
  coinbaseApp: 'Coinbase App',
  exodusApp: 'Exodus App',
  cryptoComDefi: 'Crypto.com DeFi',
  bonusRowsState1: '$1.5 billion in 2023',
  bonusRowsGrowth1: '$1.5 billion in 2023',
  bonusRowsState2: '320+ million crypto users',
  multiformatSupport: 'Multiformat support',
  iosAndroidDesktopLightVersion: 'iOS, Android, Desktop (Light Version)',
  iosAndroid: 'iOS, Android',
  iosAndroidChrome: 'iOS, Android, Chrome',
  iosAndroidBrowser: 'iOS, Android, Browser',
  iosAndroidDesktop: 'iOS, Android, Desktop',
  biometricPin2Fa:
    'Biometric, PIN, 2FA, SSL pinning, AES-256 encryption, `Emergency Stop`, `Anti-Hijack`',
  ethereum: 'Ethereum',

  poweredBy: 'Powered by',
  live: 'Live',

  auditAndKycVerified: 'Audit & KYC Verified',
  teamKycVerification: 'Team KYC Verification',
  smartContractAudit: 'Smart Contract Audit',
  securityComesFirst: 'Security comes first.',
  ourSmartContractHasBeenFullyAudited:
    'Our smart contract has been fully audited',
  bySolidProof: 'by SolidProof,',
  oneOfTheLeadingBlockchainAuditFirms:
    'one of the leading blockchain audit firms.',
  additionally: 'Additionally,',
  dollumTeamCompletedKYC:
    'the Dollum team successfully completed the KYC verification',
  ensuringTransparencyAndAccountability:
    ', ensuring transparency and accountability for our community.',
  servicesAndCertificates: 'Services & Certificates',
  kyc: 'KYC',
  securityScore: 'Security Score',
  poor: 'Poor',
  excellent: 'Excellent',
  writesMediaAboutUs: 'Media about us',

  stageTwoAlmostSold: 'Stage 2 Almost Sold Out — Next Price: $0.20',
  buyBeforeThePriceIncreases: 'Buy now at $0.15 before the price increases!',
};
